var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var CommonUtils = require('../../utils/common-utils.js');
var VitalsForm = require('./patient-vitals-form');

var Radio = require('backbone.radio');
var services = Radio.channel('services');
var notificationsChannel = Radio.channel('notifications');
var utils = new CommonUtils();

var PatientVitalsRowView = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../templates/medicals/patient-vitals-row.html'),

    ui: {
        edit: '.edit',
        remove: '.remove'
    },

    events: {
        'click @ui.edit': 'onEdit',
        'click @ui.remove': 'onRemove'
    },

    templateContext: function () {
        var that = this;
        var time = that.model.get('time');
        return {
            canEdit: that.canEdit,
            status: that.model.get('status'),
            time: time != undefined && time != '' && !isNaN(time)
                ? utils.longToDateTimeFormatted(time, "MM/DD/YYYY hh:mm A") : '-'
        }
    },

    initialize: function (options) {
        var that = this;
    },

    onRender: function () {
    },

    onEdit: function() {
        this.triggerMethod('edit:vital', {model: this.model});
    },

    onRemove: function() {
        this.triggerMethod('remove:vital', {model: this.model});
    }
});


var EmptyView = Marionette.View.extend({
    tagName: 'tr',
    template: _.template(_.reduce(_.map(_.range(1), function (value) {
        return '<td>-</td>'
    }), function (memo, str) {
        return memo + str;
    }, ""))
});

var PatientVitalsTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: PatientVitalsRowView,
    emptyView: EmptyView,

    collectionEvents: {},

    childViewEvents: {
        'remove:vital': 'removeVital',
        'edit:vital': 'editVital'
    },

    initialize: function (options) {
        this.collection = options.collection;
    },

    childViewOptions: function () {
        return {
        };
    },

    removeDisease: function(data) {
        this.triggerMethod('remove:vital', data);
    },

    editVital: function(data) {
        this.triggerMethod('edit:vital', data);
    }
});

var PatientVitals = Marionette.View.extend({
    template: require('../../templates/medicals/patient-vitals.html'),

    regions: {
        body: {
            el: 'tbody',
            replaceElement: true
        },
        vitalsForm: '#vital-form'
    },

    ui: {
        addVital: '#add',
    },

    events: {
        'click @ui.addVital': 'addNewVital',

    },

    childViewEvents: {
        'new:vital': 'saveNewVital',
        'update:vital': 'updateVital',
        'remove:vital': 'removeVital',
        'delete:confirmed': 'deleteConfirmed',
        'edit:vital': 'editVital'
    },

    templateContext: function () {
        var that = this;
        return {
            canEdit: that.canEdit,
            name: that.name
        }
    },


    initialize: function (options) {
        _.bindAll(this, 'onRender', 'showLoading', 'hideLoading', 'logError');
        this.medProfileModel = options.medProfileModel;
        this.name = options.name;
        this.canEdit = options.canEdit;
      //  var personId = this.medProfileModel.get('object').personId;
        this.collection = new Backbone.Collection(this.medProfileModel.get('object').vitals);
    },

    onRender: function () {
        var that = this;

        var vitals = that.medProfileModel.get('object').vitals;
        this.vitalsCollection = new Backbone.Collection(vitals);
        this.showChildView('body', new PatientVitalsTableBody({
            collection: this.vitalsCollection
        }));
    },

    addNewVital: function () {
        this.showChildView('vitalsForm', new VitalsForm({
            mode: 'add',
            vital: {}
        }));
    },

    editVital: function (data) {
        this.showChildView('vitalsForm', new VitalsForm({
            mode: 'edit',
            vital: data.model.toJSON(),
            servicesAddresses: this.servicesAddresses
        }));
    },

    saveNewVital: function (vital) {
        var that = this;
        utils.showSpinner();
        $.ajax({
            type: "POST",
            url: '/api/medprofile/' + this.medProfileModel.get('id') + '/vital',
            data: JSON.stringify(vital),
            contentType: 'application/json',
            statusCode: {
                200: function (response) {
                    utils.hideSpinner();
                    that.medProfileModel = new MedProfileModel(response);
                    that.vitalsCollection.reset(that.medProfileModel.get('object').vitals);
                }
            },
            error: function(e) {
                notificationsChannel.request('show:notification', e.responseJSON);
                utils.hideSpinner();
            }
        });
    },

    updateVital: function(vital) {
        var that = this;
        utils.showSpinner();
        $.ajax({
            type: "PUT",
            url: '/api/medprofile/' + this.medProfileModel.get('id') + '/vital',
            data: JSON.stringify(vital),
            contentType: 'application/json',
            statusCode: {
                200: function (response) {
                    utils.hideSpinner();
                    that.medProfileModel = new MedProfileModel(response);
                    that.vitalsCollection.reset(that.medProfileModel.get('object').vitals);
                }
            },
            error: function(e) {
                notificationsChannel.request('show:notification', e.responseJSON);
                utils.hideSpinner();
            }
        });
    },

    deleteConfirmed: function(value) {
        if (value == true) {
            var that = this;
            var uuid = that.delModel.get('uuid');
            utils.showSpinner();
            $.ajax({
                type: "DELETE",
                url: '/api/medprofile/' + this.medProfileModel.get('id') + '/vital/' + uuid,
                statusCode: {
                    200: function (response) {
                        utils.hideSpinner();
                        that.medProfileModel = new MedProfileModel(response);
                        that.vitalsCollection.reset(that.medProfileModel.get('object').vitals);
                    }
                },
                error: function (e) {
                    notificationsChannel.request('show:notification', e.responseJSON);
                    utils.hideSpinner();
                }
            });
        }
    },

    removeVital: function (data) {
        this.delModel = data.model;
        this.deleteConfirmationModal =
            new DeleteConfirmationModal({
                message: 'Enter: "confirm" if you agree to remove the vital.',
                confirmationAnswer: 'confirm'
            });
        this.showChildView('deleteConfirmationModal', this.deleteConfirmationModal);
        this.deleteConfirmationModal.show();
    },
/*
    onMerge: function (data) {
        var mergeTo = this.medProfileModel.get('object').personId;
        var mergeFrom = data.selectedId;

        if (_.isEmpty(mergeTo) || _.isEmpty(mergeFrom))
            return;

        Backbone.history.navigate('merge-persons/' + mergeTo + '/' + mergeFrom, {trigger: true});
    },*/

    showLoading: function () {
        utils.showSpinner();
    },

    hideLoading: function () {
        utils.hideSpinner();
    },

    logError: function (error) {
        utils.hideSpinner();
        notificationsChannel.request('show:notification', JSON.parse(error));
    }

});

module.exports = PatientVitals;


//////////////////
// WEBPACK FOOTER
// ./app/views/medicals/patient-vitals-view.js
// module id = 381
// module chunks = 0